import { LandingTranslationType } from "../../features/landing.types";

export const landing: LandingTranslationType = {
  landing: {
    hero: {
      title: "Gestalte deine Geschichte mit KI",
      subtitle: "Wo Fantasie auf künstliche Intelligenz trifft",
      description: "Nutze unsere interaktive, KI-gestützte Storytelling-Plattform, um fesselnde Geschichten und Charaktere zu erschaffen",
      startStory: "Starte deine Geschichte",
      signIn: "Anmelden"
    },
    features: {
      title: "Entfessle deine Kreativität",
      aiPowered: {
        title: "KI-gesteuerte Geschichten",
        description: "Erstelle einzigartige Erzählungen mit unserer fortschrittlichen KI-Story-Engine"
      },
      interactiveChoices: {
        title: "Interaktive Entscheidungen",
        description: "Gestalte deine Geschichte durch bedeutungsvolle Entscheidungen und individuelle Aktionen"
      },
      creativeFreedom: {
        title: "Kreative Freiheit",
        description: "Schreibe deinen eigenen Weg mit unbegrenzten kreativen Möglichkeiten"
      }
    },
    preview: {
      title: "Vorschau einer Geschichte",
      storyText: "Die alte Tür knarrte auf und offenbarte eine in ätherisches blaues Licht getauchte Kammer. Kristallformationen ragten aus den Wänden hervor, ihre Oberflächen spiegelten unzählige kleine Regenbögen im Raum wider. In der Mitte, wenige Zentimeter über einem Sockel aus schwarzem Marmor schwebend, lag ein Buch, das in etwas gebunden war, das wie Sternenlicht selbst aussah...",
      whatToDo: "Was tust du?",
      choice1: "Nähere dich dem Buch vorsichtig und suche den Raum nach Fallen ab",
      choice2: "Nutze deine Magie, um gefährliche Verzauberungen zu spüren",
      choice3: "Greife mutig nach dem Buch - Glück begünstigt die Mutigen!"
    },
    storyPreview: {
      header: "Erleben Sie Immersives Geschichtenerzählen",
      description: "Erstellen, erkunden und gestalten Sie Geschichten in einer dynamischen interaktiven Umgebung mit {{appName}}",
      genres: "Genres",
      themes: "Themen",
      environment: "Umgebung",
      writeResponse: "Schreiben Sie Ihre eigene Antwort...",
      previousStory: "Vorherige Geschichte",
      nextStory: "Nächste Geschichte",
      goToStory: "Zur Geschichte {{number}}"
    },
    callToAction: {
      title: "Bereit, deine Reise zu beginnen?",
      subtitle: "Schließe dich Tausenden von Geschichtenerzählern an, die einzigartige Abenteuer mit KI erschaffen",
      button: "Jetzt mit dem Schreiben beginnen"
    },
    creativeSuite: {
      title: "Kreativ-Suite",
      description: "Leistungsstarke Werkzeuge, um Ihr Erzählpotenzial freizusetzen und Ihrer Fantasie Leben einzuhauchen",
      categories: {
        stories: "Geschichten",
        characters: "Charaktere",
        premium: "Premium"
      },
      premiumFeature: "Premium-Funktion",
      basicFeature: "Verfügbar im Basis-Plan",
      freeFeature: "Kostenlos für alle",
      getStarted: "Jetzt starten",
      noCreditCard: "Keine Kreditkarte erforderlich, um Ihre kreative Reise zu beginnen",
      tools: {
        aiWriting: {
          title: "KI-gestütztes Schreiben",
          description: "Erstellen Sie Wähle-Dein-Abenteuer-Geschichten mit fortschrittlicher KI. Fahren Sie mit Antwortvorschlägen fort oder schreiben Sie Ihre eigenen."
        },
        genresThemes: {
          title: "Umfangreiche Genres, Themen und Umgebungen",
          description: "Als kostenloser Benutzer haben Sie Zugriff auf eine begrenzte Auswahl an Genres oder schalten alle Genres und Themen mit dem Basis-Plan frei."
        },
        sequels: {
          title: "Fortsetzungen und Seriengeschichten",
          description: "Setzen Sie Ihre besten Geschichten mit Fortsetzungen fort und bauen Sie fesselnde Geschichtenserien auf."
        },
        characterBuilder: {
          title: "Charakter-Builder",
          description: "Entwerfen Sie komplexe Charaktere mit detaillierten Persönlichkeiten, Motivationen und Hintergrundgeschichten."
        },
        aiPortraits: {
          title: "KI-Charakter-Portraits",
          description: "Erstellen Sie einzigartige visuelle Darstellungen Ihrer Charaktere mit unserem KI-Portrait-Generator."
        },
        characterExtract: {
          title: "Charakter-Extraktion",
          description: "Extrahieren Sie automatisch Charaktere aus Ihren Geschichten, um Ihre Charakter-Bibliothek aufzubauen."
        },
        sharing: {
          title: "Geschichten teilen und veröffentlichen",
          description: "Teilen Sie Ihre Geschichten und machen Sie sie öffentlich zugänglich, damit andere sie genießen und schätzen können."
        },
        unlimitedStorage: {
          title: "Erhöhtes Geschichtenlimit",
          description: "Erstellen Sie bis zu 5 Geschichten pro Tag mit dem kostenlosen Plan, 25 mit dem Basis-Plan oder unbegrenzte Geschichten mit Premium."
        },
        statsBadges: {
          title: "Statistiken und Abzeichen",
          description: "Verfolgen Sie Ihre Schreibstatistiken und verdienen Sie Abzeichen für Ihre Erzählerfolge."
        }
      }
    },
    exampleStories: {
      dragonsRiddle: {
        title: "Das Rätsel des Drachen",
        excerpt: "Der uralte Drache stellte ein Rätsel, das seit Jahrhunderten ungelöst geblieben war. \"Antworte richtig\", knurrte er, \"und ich gewähre dir den Durchgang durch den Berg.\" Die Schuppen des gewaltigen Wesens glänzten wie Obsidian im schwachen Höhlenlicht. Ich stand da, mit zitternden Fingerspitzen an kaltem Stein, meine Gefährten erstarrt hinter mir. Die bernsteinfarbenen Augen des Drachen fixierten meine. \"Aber wenn du versagst\", fuhr das Biest fort, \"wirst du dich den Knochen derer anschließen, die vor dir kamen.\" Es deutete auf verstreute Überreste, die ich versucht hatte nicht zu bemerken. Drachen liebten Wortspiele und versteckte Bedeutungen. Das Schicksal unserer Quest hing von meiner Fähigkeit ab, das Rätsel des Geschöpfs zu entschlüsseln.",
        suggestion1: "\"Die Antwort ist 'Zeit' - sie verschlingt alles, wird aber selbst nie verzehrt\", verkündete ich mit mehr Selbstvertrauen, als ich fühlte.",
        suggestion2: "Ich verbeugte mich respektvoll vor dem uralten Biest. \"Großer, darf ich eine klärende Frage zu deinem Rätsel stellen?\"",
        suggestion3: "Ich blickte auf die ängstlichen Gesichter meiner Gefährten, bevor ich mich wieder dem Drachen zuwandte. \"Vielleicht könnten wir einen anderen Weg hindurch verhandeln?\""
      },
      echoesFromTomorrow: {
        title: "Echos aus dem Morgen",
        excerpt: "Dr. Miranda Chen starrte auf die Nachricht auf ihrem Bildschirm. Sie war gestern angekommen, aber der Zeitstempel zeigte, dass sie morgen gesendet wurde. Sie las sie erneut: \"Protokoll Omega initiiert. Testsequenz NICHT fortsetzen. Katastrophaler zeitlicher Kollaps unmittelbar bevorstehend.\" Miranda überprüfte das von ihr entworfene Quantenkommunikationsfeld – es sollte die Signallatenz reduzieren, nicht den Schleier zwischen Jetzt und Morgen durchdringen. Die in der Nachricht eingebetteten Quantensignaturen stimmten genau mit ihren Verschlüsselungsprotokollen überein, mit einer unmöglichen Anomalie: Sie zeigten Zerfallsmuster, die noch nicht existieren konnten. Als ihr Terminal mit einer weiteren eingehenden Nachricht klingelte, fühlte Miranda einen Schauer. Die Absender-ID zeigte ihren eigenen Namen.",
        suggestion1: "Miranda tippte schnell: \"Hier spricht Dr. Chen. Identifizieren Sie sich und erklären Sie, wie Sie auf unsere sicheren Systeme zugreifen.\"",
        suggestion2: "Sie leitete eine Notabschaltung ein, während sie alle Projektdaten auf dem sicheren externen Server sicherte.",
        suggestion3: "Sie rief ihren Forschungspartner an: \"Kenji, etwas Unmögliches passiert mit dem Quantenfeld.\""
      },
      forgottenLibrary: {
        title: "Die Vergessene Bibliothek",
        excerpt: "Die Bibliothek erschien nur in regnerischen Nächten, ihre Türen öffneten sich für jene, die Antworten am dringendsten benötigten. Ich hatte jahrelang nach ihr gesucht, Gerüchten und obskuren Hinweisen folgend. Jetzt, als ich vor ihrer unmöglichen Architektur stand – innen größer als außen – zögerte ich. Die massiven Eichentüren standen leicht offen, warmes Licht ergoss sich auf nasse Kopfsteinpflaster. Die Eingangshalle erhob sich unglaublich hoch, Regale erstreckten sich über den Punkt hinaus, wo die Decke sein sollte. Die Luft roch nach Papier, Tinte und etwas Älterem – als ob die Zeit selbst einen Geruch hätte. Ich bemerkte, dass die Flüstern stärker wurden, kommend von tausenden Büchern, die alle gleichzeitig sprachen. Dann erhob sich eine Stimme über den anderen: \"Wir haben auf dich gewartet.\"",
        suggestion1: "\"Wer ist da?\" rief ich, meine Stimme hallte durch den höhlenartigen Raum, während ich die schattigen Gänge absuchte.",
        suggestion2: "Ich näherte mich dem nächsten Regal und ließ meine Finger über die alten Buchrücken gleiten, mich fragend, welches Buch gesprochen hatte.",
        suggestion3: "\"Ich bin gekommen, um Informationen über die Himmlische Konvergenz zu suchen\", verkündete ich der flüsternden Bibliothek."
      }
    }
  }
};
